// extracted by mini-css-extract-plugin
export var container = "OxcpAPaW";
export var containerColorLime = "r5uy33iU";
export var containerColorCactus = "vboTKo8F";
export var containerColorRed = "mpUAkzFR";
export var containerColorYellow = "Ml1mZ2y7";
export var containerColorDisabled = "_3wZkMRBR";
export var containerColorWhite = "a3mFkdJ7";
export var containerColorGray = "_8Zwlzf0f";
export var containerColorDarkviolet = "MUbIuPwU";
export var containerColorCharcoal = "_3kuFz8K7";
export var containerTypeFull = "z5gD2DjG";
export var content = "-3X3Z7Do";
export var contentTypeDefault = "bVuq6oVE";
export var contentTypeFull = "SBddY3Ic";